import axios from "axios";

const BASE = (process.env.REACT_APP_EZTS_API_BASE_URL || "").replace(/\/+$/, "");

function getJwtToken() {
  const raw = localStorage.getItem("ezts_auth");
  if (!raw) return null;

  if (raw.startsWith("eyJ")) return raw;

  try {
    const obj = JSON.parse(raw);
    return obj?.token || obj?.accessToken || obj?.jwt || null;
  } catch {
    return null;
  }
}

// ✅ KEEP THIS — list API
export async function getExpenses({ filters }) {
  const jwt = getJwtToken();
  if (!jwt) throw new Error("Missing/invalid auth token (ezts_auth)");

  const url = `${BASE}/expense/all`;

  const res = await axios.get(url, {
    params: { orgId: 1, ...(filters || {}) },
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  });

  return res.data;
}

export async function getExpenseTypes({ orgId = 1 } = {}) {
  const jwt = getJwtToken();
  if (!jwt) throw new Error("Missing/invalid auth token (ezts_auth)");

  const url = `${BASE}/expense/expense_type/all`;

  const res = await axios.get(url, {
    params: { orgId },   // <-- exactly as Swagger shows
    headers: { Authorization: `Bearer ${jwt}` },
  });

  return Array.isArray(res.data) ? res.data : [];
}



export async function updateExpenseStatus({ expenseId, status }) {
  const jwt = getJwtToken();
  if (!jwt) throw new Error("Missing/invalid auth token (ezts_auth)");

  const url = `${BASE}/expense/status`;

  const res = await axios.put(
    url,
    null, // no JSON body
    {
      params: { expenseId, status },
      headers: { Authorization: `Bearer ${jwt}` },
    }
  );

  return res.data;
}

export async function createExpense(payload) {
  const jwt = getJwtToken();
  if (!jwt) throw new Error("Missing/invalid auth token (ezts_auth)");

  const url = `${BASE}/expense`;

  const res = await axios.post(url, payload, {
    headers: { Authorization: `Bearer ${jwt}` },
  });

  return res
}
